/**
 * Standardized multi-ring spinner component. Matches the audit loader dialog spinner — uses the
 * same CSS classes at different scales.
 *
 * @param {"sm" | "md" | "lg"} size – sm (48px), md (72px), lg (120px, default)
 * @param {string} message – optional status message below spinner
 * @param {string} className – additional wrapper classes
 */
const LoadingSpinner = ({ size = "md", message, className = "" }) => {
  const sizeClass = size === "sm" ? "spinner-sm" : size === "md" ? "spinner-md" : "";

  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${sizeClass} ${className}`}>
      <div className="audit-spinner-container">
        <div className="audit-spinner-ring audit-ring-1" />
        <div className="audit-spinner-ring audit-ring-2" />
        <div className="audit-spinner-ring audit-ring-3" />
        <div className="audit-spinner-core" />
      </div>
      {message && (
        <p className="text-on-surface-variant text-sm font-medium animate-pulse">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
